import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Clock } from "lucide-react";

export default function PendingApproval() {
    const { user, logout } = useAuth();
    return (
        <section className="max-w-2xl mx-auto px-5 md:px-10 py-16 md:py-24 text-center" data-testid="pending-page">
            <Clock size={40} color="#D4BC7C" strokeWidth={1} className="mx-auto" />
            <p className="bc-label-small mt-6">En attente de validation</p>
            <h1 className="font-serif text-[#D4BC7C] text-4xl sm:text-5xl mt-4">Merci pour votre demande</h1>
            <div className="bc-hairline-gold my-8 mx-auto" />
            <p className="text-[#F2ECE0]/85 leading-relaxed text-base max-w-lg mx-auto">
                Votre demande d'accès à l'Espace Pro est actuellement <strong className="text-[#D4BC7C]">en cours de validation</strong> par
                notre équipe. Vous recevrez une confirmation par e-mail dès son activation
                (généralement sous 24-48h).
            </p>
            {user && (
                <p className="text-sm text-[#A0A0A0] mt-6">
                    Connecté en tant que <span className="text-[#D4BC7C]">{user.email}</span>
                </p>
            )}
            <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/" className="bc-btn bc-btn--ghost" data-testid="pending-back-home">
                    Retour à l'accueil
                </Link>
                {user && (
                    <button className="bc-btn" onClick={logout} data-testid="pending-logout">
                        Se déconnecter
                    </button>
                )}
            </div>
        </section>
    );
}
